module.exports = __webpack_public_path__ + "static/crafter-okul-2ea8c34685f258c18c287ac4e1322e0e.png";